const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Touch {
    constructor(runtime) { this.runtime = runtime; this._t = []; var self = this; document.addEventListener('touchstart', function(e) { self._t = Array.from(e.touches); }); document.addEventListener('touchmove', function(e) { self._t = Array.from(e.touches); }); document.addEventListener('touchend', function(e) { self._t = Array.from(e.touches); }); }
    getInfo() {
        return {
            id: 'touchExt', name: '👆 タッチ', color1: '#F59E0B', color2: '#D97706',
            blocks: [
                { opcode: 'touching', blockType: BlockType.BOOLEAN, text: 'タッチされている？' },
                { opcode: 'count', blockType: BlockType.REPORTER, text: 'タッチ数' },
                { opcode: 'x', blockType: BlockType.REPORTER, text: 'タッチ [N] のX', arguments: { N: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'y', blockType: BlockType.REPORTER, text: 'タッチ [N] のY', arguments: { N: { type: ArgumentType.NUMBER, defaultValue: 1 } } }
            ]
        };
    }
    touching() { return this._t.length > 0; }
    count() { return this._t.length; }
    x(args) { var t = this._t[Cast.toNumber(args.N) - 1]; return t ? t.clientX : 0; }
    y(args) { var t = this._t[Cast.toNumber(args.N) - 1]; return t ? t.clientY : 0; }
}
module.exports = Scratch3Touch;